// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sS uC","ribbon":"sT uL","title":"sU uE","seasons":"sV uJ","genres":"sW uK","buttonWrapper":"sX uG","button":"sY uH"};